import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import BaseLayer from "../core/BaseLayer";
import WindModels from "./models";
export default class WindLayer extends BaseLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "type", 'WindLayer');
  }
  buildModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      const modelType = _this.getModelType();
      _this.layerModel = new WindModels[modelType](_this);
      yield _this.initLayerModels();
    })();
  }
  renderModels(options = {}) {
    if (this.layerModel) {
      this.layerModel.render(options); // 独立的渲染流程
    }
    return this;
  }
  getDefaultConfig() {
    const type = this.getModelType();
    const defaultConfig = {
      wind: {}
    };
    return defaultConfig[type];
  }
  getModelType() {
    return 'wind';
  }
}